module.exports = __webpack_public_path__ + "static/media/4.9b6f29b9.jpg";